"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashcardReviewEvaluator = void 0;
/**
 * Completion-only evaluator for flashcard_review activities.
 *
 * Score = 1 if `structuredData.cardResults.length === config.cards.length`
 * (all cards reviewed), 0 otherwise. Does NOT inspect or score stroke content —
 * write-back strokes are saved for teacher review but not auto-scored
 * (handwriting-first principle: the teacher sees the child's actual handwriting).
 */
class FlashcardReviewEvaluator {
    async evaluate(submission, activity) {
        const config = activity.config;
        const cards = Array.isArray(config.cards) ? config.cards : [];
        const cardResults = Array.isArray(submission.structuredData?.cardResults)
            ? submission.structuredData.cardResults
            : [];
        const isComplete = cards.length > 0 && cardResults.length === cards.length;
        const score = isComplete ? 1 : 0;
        return {
            score,
            maxScore: 1,
            isCorrect: isComplete,
            feedback: isComplete
                ? 'All cards reviewed.'
                : `Reviewed ${cardResults.length} of ${cards.length} cards.`,
            breakdown: [
                {
                    name: 'Completion',
                    score,
                    maxScore: 1,
                    feedback: isComplete
                        ? 'Deck complete'
                        : 'Deck incomplete',
                },
            ],
            skills: [{ key: 'flashcard:completion', label: 'Flashcard Review' }],
            label: 'Flashcard Review',
        };
    }
}
exports.FlashcardReviewEvaluator = FlashcardReviewEvaluator;
